var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#707070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.338 5.67263C5.03099 5.54737 4.90051 5.18263 5.08472 4.91737C5.45697 4.38684 6.07866 4 6.8999 4C7.80174 4 8.41959 4.39421 8.73427 4.88789C9.00291 5.31158 9.16025 6.10368 8.74579 6.69316C8.28527 7.34526 7.84395 7.54421 7.60602 7.96421C7.54846 8.06368 7.51392 8.14474 7.49089 8.31053C7.45635 8.57947 7.2261 8.78947 6.94212 8.78947C6.60824 8.78947 6.33578 8.51316 6.37415 8.19263C6.39718 8.00474 6.44323 7.80947 6.55068 7.62526C6.84618 7.11316 7.41414 6.81105 7.74417 6.35789C8.09339 5.88263 7.89768 4.99474 6.90758 4.99474C6.45858 4.99474 6.16692 5.21947 5.98655 5.48842C5.85224 5.69842 5.57209 5.76474 5.338 5.67263ZM7.67126 10.2632C7.67126 10.6684 7.32588 11 6.90374 11C6.4816 11 6.13622 10.6684 6.13622 10.2632C6.13622 9.85789 6.4816 9.52632 6.90374 9.52632C7.32588 9.52632 7.67126 9.85789 7.67126 10.2632Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c359cc63936a9074ecd0b30ad6921b15.svg";
export { ForwardRef as ReactComponent };